import React, { useState } from "react";
import { Table, Row, Col, Typography, Button, Space, message } from "antd";
import ContractorReferencesModal from "./ContractorReferencesModal";
import { removeContractorReference } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { ContractorReferencesColumns } from "../../../../PQQ/tableColumns";

const { Paragraph } = Typography;

const ContractorReferences = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchContractorReference();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeContractorReference({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...ContractorReferencesColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Paragraph className="mandatory-field-mark">
          Provide names and contact information for at least three contractors
          for whom you have worked:
        </Paragraph>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Contractor
        </Button>
      </Col>
      <Col span={22} offset={1}>
        <Table
          size="small"
          columns={columns}
          dataSource={props.contractorReferenceData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <ContractorReferencesModal
          setVisible={setVisible}
          title="Add Contractor Reference"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default ContractorReferences;
